import { render } from "./NewAchievement.vue?vue&type=template&id=a93926d4&scoped=true"
import script from "./NewAchievement.vue?vue&type=script&lang=js"
export * from "./NewAchievement.vue?vue&type=script&lang=js"

import "./NewAchievement.vue?vue&type=style&index=0&id=a93926d4&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src1692007530/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93926d4"]])

export default __exports__